// extracted by mini-css-extract-plugin
export default {"user":"User_user__goWEA","user-name":"User_user-name__eHY9g","user-name-container":"User_user-name-container__enneb","loading-value":"User_loading-value__PyoU6"};